import { useEffect, useRef, useState } from "react";

import { Observation } from "@medplum/fhirtypes";

import {
  LABOR_QUESTIONNAIRE_DISPLAY_NAMES,
  QuestionnaireType,
} from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";
import { useLaborFlowsheetEditRouteContext } from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/use-labor-flowsheet-edit-route-context";
import { MembranesFlowsheetDrawer } from "@/encounters/components/EncounterLabor/flowsheet-forms/membranes";

interface EditMembranesLaborRowProps {
  observation: Observation;
  onClose?: () => void;
}

export default function EditMembranesLaborRow({
  observation,
  onClose,
}: EditMembranesLaborRowProps) {
  const [opened, setOpened] = useState(true);
  const { encounterId, clientId, hasRouteContext } = useLaborFlowsheetEditRouteContext(onClose);
  const questionnaireDisplayName =
    observation.code?.coding?.[0]?.display ??
    LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.Membranes];

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (hasRouteContext) {
      return;
    }
    setOpened(false);
  }, [hasRouteContext]);

  const handleClose = () => {
    setOpened(false);
    onCloseRef.current?.();
  };

  if (!hasRouteContext || !encounterId || !clientId) {
    return null;
  }

  return (
    <MembranesFlowsheetDrawer
      mode="edit"
      opened={opened}
      clientId={clientId}
      onClose={handleClose}
      encounterId={encounterId}
      observation={observation}
      title={questionnaireDisplayName}
      questionnaireDisplayName={questionnaireDisplayName}
    />
  );
}
